var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.755 6.173c0 1.752-1.512 3.173-3.378 3.173C3.512 9.346 2 7.926 2 6.173S3.512 3 5.377 3c1.866 0 3.378 1.42 3.378 3.173M2.462 11.678h5.773V29.25H2.462zM17.53 11.678h-5.773V29.25h5.773v-8.99c0-2.077.706-4.162 3.521-4.162 3.183 0 3.164 2.717 3.149 4.822-.02 2.75.027 5.558.027 8.33H30v-9.274c-.049-5.922-1.585-8.65-6.64-8.65-3 0-4.861 1.368-5.83 2.606z"
  })));
};
export default SvgLinkedin;